import React, { useState } from 'react';
import { showAppAlert } from '../utils/alertService';
import LoaderOverlay from './LoaderOverlay';
import '../styles/formStyles.css';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function ForgotPasswordModal({ isOpen, onClose }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      showAppAlert('warning', 'Por favor, insira seu e-mail.');
      return;
    }
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/password/forgot`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      // Independentemente do resultado, mostramos uma mensagem genérica por segurança
      // para evitar que atacantes descubram quais e-mails estão cadastrados.
      if (response.ok) {
        showAppAlert('success', 'Se um e-mail correspondente for encontrado, um link de redefinição de senha será enviado.');
      } else {
        // Mesmo em caso de erro, a mensagem é a mesma para o usuário.
        // O erro real pode ser logado no console para depuração.
        const errorData = await response.text();
        console.error("Erro na API de 'forgot-password':", errorData);
        showAppAlert('success', 'Se um e-mail correspondente for encontrado, um link de redefinição de senha será enviado.');
      }
      
      onClose();

    } catch (error) {
      console.error('Erro ao solicitar redefinição de senha:', error);
      showAppAlert('error', 'Ocorreu um erro ao processar sua solicitação. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <LoaderOverlay isLoading={loading} message="Processando..." />
      <div className="modal-content" style={{ maxWidth: 400 }}>
        <h3>Esqueci a Senha</h3>
        <p style={{ margin: '15px 0' }}>
          Digite seu e-mail abaixo para receber as instruções de como redefinir sua senha.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="label-style">
            <label>E-mail:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-style input-medium"
              required
            />
          </div>
          <div className="button-container">
            <button type="submit" className="button-style" disabled={loading}>Enviar</button>
            <button type="button" onClick={onClose} className="button-style cancel" disabled={loading}>Cancelar</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ForgotPasswordModal;